exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "input._3_eQWDAzbCApOsQTr7uXwB{margin:0 10px 0 0}label._2caSMmJe8WhLc2ougZiWZ1{width:49%;display:inline-block}label.XYe7p7Io5cvpPDnCTbqan{width:auto;display:block}\n", ""]);

// Exports
exports.locals = {
	"checkbox": "_3_eQWDAzbCApOsQTr7uXwB",
	"label": "_2caSMmJe8WhLc2ougZiWZ1",
	"labelHorizontal": "XYe7p7Io5cvpPDnCTbqan"
};